import VideoCanvas from './VideoCanvas'

class Home {
    namespace: HTMLElement | null;
    constructor() {
        this.namespace = document.getElementById('page-welcome');  
        
        this.initPage();
    }

    initPage() {
        if (!this.namespace) return;
        new VideoCanvas();

    } 
}

export default Home;